import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button } from '@mui/material';
import CookieConsent from "react-cookie-consent";
import PhotoGallery from './PhotoGallery';
import ArtistInfo from './ArtistInfo'; 
import ArtisticVision from './ArtisticVision'; 
import Impressum from './Impressum';
import Datenschutz from './Datenschutz'; 
import Contact from './Contact';
import Footer from './Footer';  
import globalStyles from './styles/GlobalStyles.module.css';  
import headerStyles from './styles/AppHeader.module.css';
import { initAnalytics } from './firebase';

// Helferfunktion zum Lesen eines Cookies
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
}

// Helferfunktion zum Löschen eines Cookies
function eraseCookie(name) {
  document.cookie = name + '=; Max-Age=-99999999; path=/';
}

function App() {
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const measurementId = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID;
  // Banner anzeigen, wenn der Cookie noch nicht existiert
  const [showCookieBanner, setShowCookieBanner] = useState(
    getCookie("cookie_consent") === null
  );

  // Aktiviere Analytics automatisch, wenn der User bereits früher zugestimmt hat
  React.useEffect(() => {
    const consentValue = getCookie("cookie_consent");
    if (consentValue === "granted") {
      if (measurementId) {
        window[`ga-disable-${measurementId}`] = false;
      }
      window.gtag("consent", "update", {
        ad_storage: "granted",
        analytics_storage: "granted"
      });
      initAnalytics();
      setShowCookieBanner(false);
    }
  }, [measurementId]);

  const handleAcceptCookies = () => {
    if (measurementId) {
      window[`ga-disable-${measurementId}`] = false;
    }
    // Update GTM-Consent oder andere Logik hier
    window.gtag("consent", "update", {
      ad_storage: "granted",
      analytics_storage: "granted"
    });
    initAnalytics();
    setShowCookieBanner(false);
  };

  const deleteAnalyticsCookies = () => {
    console.log("Lösche Google Analytics Cookies...");
    const cookiesToDelete = ["_ga", "_ga_NFD9CS3KV8"];
    cookiesToDelete.forEach((cookie) => {
      document.cookie = `${cookie}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
      document.cookie = `${cookie}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${window.location.hostname}`;
    });
    console.log("Alle Google Analytics Cookies gelöscht!");
  };

  const handleDeclineCookies = () => {
    console.log("Cookies abgelehnt!");
    if (measurementId) {
      window[`ga-disable-${measurementId}`] = true;
    }
    window.gtag("consent", "update", {
      ad_storage: "denied",
      analytics_storage: "denied"
    });
    deleteAnalyticsCookies();
    setShowCookieBanner(false);
  };

  const resetCookieConsent = () => {
    console.log("Cookie-Einstellungen zurückgesetzt...");
    // Löscht den Cookie "cookie_consent"
    eraseCookie("cookie_consent");
    if (measurementId) {
      window[`ga-disable-${measurementId}`] = true;
    }
    deleteAnalyticsCookies();
    setShowCookieBanner(true);
  };

  return (
    <Router>
      <div className={globalStyles.wideContainer}>
        {/* Header nur anzeigen, wenn die Lightbox nicht geöffnet ist */}
        {!isLightboxOpen && (
          <AppBar position="sticky" className={headerStyles.appHeader}>
            <Toolbar className={headerStyles.toolbar}>
              <Typography variant="h6" className={headerStyles.appTitle}>
                Sebastian Gessenharter
              </Typography>
              <div className={headerStyles.navContainer}>
                <Button color="inherit" component={Link} to="/" className={headerStyles.navButton}>
                  Galerie
                </Button>
                <Button color="inherit" component={Link} to="/artist" className={headerStyles.navButton}>
                  Vita
                </Button>
                <Button color="inherit" component={Link} to="/vision" className={headerStyles.navButton}>
                  Zielsetzung
                </Button>
              </div>
            </Toolbar>
          </AppBar>
        )}

        {/* Routes */}
        <Routes>
          <Route path="/" element={<PhotoGallery setIsLightboxOpen={setIsLightboxOpen} />} />
          <Route path="/artist" element={<ArtistInfo />} />
          <Route path="/vision" element={<ArtisticVision />} /> 
          <Route path="/impressum" element={<Impressum />} /> 
          <Route path="/datenschutz" element={<Datenschutz resetCookieConsent={resetCookieConsent} />}/>
        </Routes>

        <Contact /> 

        {/* Footer erhält die Funktion zum Zurücksetzen */}
        <Footer resetCookieConsent={resetCookieConsent} />

        {/* Cookie-Consent Banner */}
        {showCookieBanner && (
          <CookieConsent
            key={showCookieBanner} 
            location="bottom"
            // Nur ein Cookie namens "cookie_consent" wird verwendet
            cookieName="cookie_consent"
            // Werte, die im Cookie gespeichert werden sollen:
            cookieValue="granted"
            declineCookieValue="denied"
            buttonText="Akzeptieren"
            declineButtonText="Ablehnen"
            enableDeclineButton
            onAccept={handleAcceptCookies}
            onDecline={handleDeclineCookies}
            style={{
              background: "#2B373B",
              color: "#ffffff",
              fontSize: "14px",
              padding: "15px",
              textAlign: "center"
            }}
            buttonStyle={{
              background: "#4CAF50",
              color: "#ffffff",
              fontSize: "14px",
              padding: "10px 20px",
              borderRadius: "5px"
            }}
            declineButtonStyle={{
              background: "#f44336",
              color: "#ffffff",
              fontSize: "14px",
              padding: "10px 20px",
              borderRadius: "5px"
            }}
          >
            Diese Website verwendet Cookies. Einige sind notwendig für die Funktion der Seite, andere helfen uns, Ihr Erlebnis durch Analyse- und Statistikdienste (z. B. Google Analytics) zu verbessern. Sie können wählen, ob Sie diese akzeptieren oder ablehnen möchten.
          </CookieConsent>
        )}
      </div>
    </Router>
  );
}

export default App;
